<p-tabView #TabComercial [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)" [scrollable]="true">

    <p-tabPanel *ngIf="tieneCodigosValidos(1)" header="Embarque-ETA">

        <form fxLayoutGap="20px" class="label" [formGroup]="group" style="padding: 8px;">

              <div class="a-example-full-width-alterno-content-row">
         
            <p-floatlabel variant="in" class="example-full-width-alterno1">
            <p-select id="anio" [options]="ANIOS" appendTo="body" formControlName="anio"
            styleClass="w-full h-3rem text-xs" [filter]="false" [showClear]="true" />
            <label for="anio">Año</label>
            </p-floatlabel>
    
 


            <mat-form-field *ngIf='false' appearance="outline" class="example-full-width-alterno3">
                <mat-label>Fecha Inicio</mat-label>
                <input formControlName="fechainicio" matInput [matDatepicker]="picker1" readonly>
                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 color="primary"></mat-datepicker>
            </mat-form-field>

               <p-floatlabel variant="in" class="example-full-width-alterno1">
                <p-select id="mes" [options]="MESES" appendTo="body" formControlName="mes"
                    styleClass="w-full h-3rem text-xs" [filter]="false" [showClear]="true" />
                <label for="mes">Mes</label>
            </p-floatlabel>

            <mat-form-field *ngIf='false' appearance="outline" class="example-full-width-alterno3">
                <mat-label>Fecha Fin</mat-label>
                <input formControlName="fechafin" matInput [matDatepicker]="picker2" readonly>
                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 color="primary"></mat-datepicker>
            </mat-form-field>

            

             <mat-form-field class="example-full-width-alterno3" style="height: 30px !important" appearance="outline">
                <mat-label>Regimen</mat-label>
                <mat-select formControlName="regimen">
                    <mat-option value="TODOS">TODOS</mat-option>
                    <mat-option *ngFor="let reg of listReg" [value]="reg.nombre">{{reg.nombre}}</mat-option>
                </mat-select>
            </mat-form-field> 




            <mat-form-field class="list"  class="example-full-width-alterno3"  appearance="outline"
            >
                <mat-label>Linea de Negocio</mat-label>
                <mat-select formControlName="lineanegocio" [disabled]="true">
                    <mat-option value="TODOS">TODOS</mat-option>
                    <mat-option value="MANDATO">MANDATO</mat-option>
                    <mat-option value="OTROS TRAFICOS">OTROS TRAFICOS</mat-option>
                    <mat-option value="EXPORTACIONES">EXPORTACIONES</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-radio-group aria-label="Select an option" class="checkbox-group" formControlName="fechas" *ngIf="false">
                <mat-radio-button value="a" (click)="radioaccion1()">Este - Mes</mat-radio-button>
                <mat-radio-button value="b" (click)="radioaccion2()">Personalizado</mat-radio-button>
            </mat-radio-group>

            <button mat-raised-button class="button1" (click)="cargarinformacion()">Buscar</button>
    </div>   
        </form>

        <!-- <div class="rectangulo">
            <div class="scroll">
                <div class="primercontenido">
                    <div class="items0">
                        <div>
                            <span class="redim">TEUS Cerrados Equipo Comercial2 </span>
                            <span class="inferiores">{{fechasuperior}}</span>
                        </div>
                        <span class="inferiores">{{fechaactual}}</span>
                    </div>
                    <span class="separador"></span>
                    <div class="items1">
                        <span>{{ getTotalCost('monto',datatlable) }}</span>
                        <span class="inferiores">*BudM</span>
                    </div>
                    <span class="separador"></span>
                    <div class="items1">
                        <span class="red">{{ getTotalCost('budmtd',datatlable) }}</span>
                        <span class="inferiores">*BudMTD</span>
                    </div>
                    <span class="separador"></span>
                    <div class="items1">
                        <span class="red">{{ getTotalCost('cantidad',datatlable) }}</span>
                        <span class="inferiores">TEU</span>
                    </div>
                    <span class="separador"></span>
                    <div class="items1">
                        <span>{{ getTotalCost('teuwk',datatlable) }}</span>
                        <span class="inferiores">TEU_WK</span>
                    </div>
                    <span class="separador"></span>
                    <div class="items1">
                        <span>{{ getTotalCost('teuhoy',datatlable) }}</span>
                        <span class="inferiores">TEU_Hoy</span>
                    </div>
                    <span class="separador"></span>
                    <div class="items1">
                        <span>{{ getTotalCost('cantidadovs',datatlable) }}</span>
                        <span class="inferiores">OV</span>
                    </div>
                    <span class="separador"></span>
                    <div class="items1">
                        <span>{{ getTotalCost('cantidadcliente',datatlable) }}</span>
                        <span class="inferiores">clientes</span>
                    </div>
                </div>
            </div>
            <div>
                <hr>
            </div>
        </div> -->

        <div class="principalgraficos">
            <!-- <div class="graficoscontenedor">
                <div class="graficos">
                    <p class="titulosgraficos">TEU vs Target Por Ejecutivo</p>
                    <div class="adaptiv">
                        <canvas id="canvas1" class="canvas-grafico">
                            {{teuvstargetejecutivo}}
                        </canvas>
                    </div>
                </div>
                <div class="graficos">
                    <p class="titulosgraficos">TEU por Ejecutivos key account</p>
                    <div class="adaptiv">
                        <canvas id="canvas_otros_ejecutivos" class="canvas-grafico">
                            {{teusOtrosEjecutivos}}
                        </canvas>
                    </div>
                </div>
            </div> -->
            <div class="graficoscontenedor">
                <div class="tablas">

                    <div class="tablecont">
                        <table>
                            <tr class="cabeceras">
                                <td>Ejecutivo</td>

                                <!-- <td>budytd</td>
                                <td>teuytd</td>
                                <td>varbudytd</td>

                                 <td>BudM 0</td>
                                <td>TEU</td>
                                <td>*BudM</td>
                            
                                <td>VarBudM</td> -->

                               <td>Budget Acum</td>
                                <td> Real Acum</td>
                                <td>Var Acum</td>

                                 <td>Budget mes</td>
                                <td>Real mes</td>
                                <td>*Forecast mes</td>
                            
                                <td>Var mes</td>
                           


                            </tr>
                            <tr class="contenidotabla" *ngFor="let item of datatlable">
                                <td
                                    style="font-weight: 500;text-align: left;text-transform: uppercase;padding-left: 10px;">
                                    {{item['entc_nomcompleto']}}
                                </td>

 <td class="red" [ngClass]="{'black': item['cantidad'] >= item['budm_0'],}">
                                    {{item['budytd']}}
                                </td>

                                 <td class="red" [ngClass]="{'black': item['cantidad'] >= item['budm_0'],}">
                                    {{item['teuytd']}}
                                </td>

                               

                                 <td class="red" [ngClass]="{'black': item['varbudytd'] >= 0,}">
                                    <div class="tablaconicono">
                                        <div>
                                            <ng-container *ngIf="item['varbudytd'] >= 0; else lessThanTen2">
                                                <img src="../../../../assets/iconos/triangle-green.svg">
                                            </ng-container>
                                            <ng-template #lessThanTen2>
                                                <img src="../../../../assets/iconos/triangle-red.svg">
                                            </ng-template>
                                        </div>
                                        <div>
                                            {{item['varbudytd']}}
                                        </div>
                                    </div>
                                </td>

                                

                                <td class="red" [ngClass]="{'black': item['cantidad'] >= item['budm_0'],}">
                                    {{item['budm_0']}}
                                </td>

                                <td class="red" [ngClass]="{'black': item['cantidad'] >= item['budmtd'],}">
                                    {{item['cantidad']}}
                                </td>
                                <td>{{item['monto']}}</td>
                                <!-- <td>{{item['budmtd']}}</td> -->
                               

                                <!-- <td class="red" [ngClass]="{'black': item['varbudmtd'] >= 0,}">
                                    <div class="tablaconicono">
                                        <div>
                                            <ng-container *ngIf="item['varbudmtd'] >= 0; else lessThanTen">
                                                <img src="../../../../assets/iconos/triangle-green.svg" alt="Mayor a 9">
                                            </ng-container>
                                            <ng-template #lessThanTen>
                                                <img src="../../../../assets/iconos/triangle-red.svg"
                                                    alt="Menor o igual a 9">
                                            </ng-template>
                                        </div>
                                        <div>
                                            {{item['varbudmtd']}}
                                        </div>
                                    </div>
                                </td> -->
                                <td class="red" [ngClass]="{'black': item['varbudm'] >= 0,}">
                                    <div class="tablaconicono">
                                        <div>
                                            <ng-container *ngIf="item['varbudm'] >= 0; else lessThanTen2">
                                                <img src="../../../../assets/iconos/triangle-green.svg">
                                            </ng-container>
                                            <ng-template #lessThanTen2>
                                                <img src="../../../../assets/iconos/triangle-red.svg">
                                            </ng-template>
                                        </div>
                                        <div>
                                            {{item['varbudm']}}
                                        </div>
                                    </div>
                                </td>
                            
                            </tr>
                            <tr class="totalestabla">
                                <td style="font-weight: 500;">
                                    TOTALES
                                </td>

                                  <td>
                                    {{ getTotalCost('budytd',datatlable) }}
                                </td>
                                  <td>
                                    {{ getTotalCost('teuytd',datatlable) }}
                                </td>
                                  <td>
                                    {{ getTotalCost('varbudytd',datatlable) }}
                                </td>


                                 <td>
                                    {{ getTotalCost('budm_0',datatlable) }}
                                </td>
                                <td>
                                    {{ getTotalCost('cantidad',datatlable) }}
                                </td>
                                <td>
                                    {{ getTotalCost('monto',datatlable) }}
                                </td>
                                <!-- <td class="red"
                                    [ngClass]="{'black': getTotalCost('cantidad',datatlable) >= getTotalCost('budmtd',datatlable),}">
                                    {{ getTotalCost('cantidad',datatlable) }}
                                </td> -->
                                <!-- <td class="red" [ngClass]="{'black': getTotalCost('varbudmtd',datatlable) >= '0',}">
                                    <div class="tablaconicono">
                                        <div>
                                            <ng-container
                                                *ngIf=" getTotalCost('varbudmtd',datatlable) >= '0'; else lessThanTen">
                                                <img src="../../../../assets/iconos/triangle-green.svg" alt="Mayor a 9">
                                            </ng-container>
                                            <ng-template #lessThanTen>
                                                <img src="../../../../assets/iconos/triangle-red.svg"
                                                    alt="Menor o igual a 9">
                                            </ng-template>
                                        </div>
                                        <div>
                                            {{ getTotalCost('varbudmtd',datatlable) }}
                                        </div>
                                    </div>
                                </td> -->
                                <td class="red" [ngClass]="{'black': getTotalCost('varbudm',datatlable) >= '0',}">
                                    <div class="tablaconicono">
                                        <div>
                                            <ng-container
                                                *ngIf=" getTotalCost('varbudm',datatlable) >= '0'; else lessThanTen">
                                                <img src="../../../../assets/iconos/triangle-green.svg" alt="Mayor a 9">
                                            </ng-container>
                                            <ng-template #lessThanTen>
                                                <img src="../../../../assets/iconos/triangle-red.svg"
                                                    alt="Menor o igual a 9">
                                            </ng-template>
                                        </div>
                                        <div>
                                            {{ getTotalCost('varbudm',datatlable) }}
                                        </div>
                                    </div>
                                </td>
                          
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <!-- <div class="graficoscontenedor">
                <div class="graficos">
                    <p class="titulosgraficos">TEU vs Target Proporcional Mes</p>
                    <div class="adaptiv">
                        <canvas id="canvas3" class="canvas-grafico" style="overflow-x: scroll;">
                            {{teuvstargetejecutivo3}}
                        </canvas>
                    </div>
                </div>
                <div class="graficos">
                    <p class="titulosgraficos">TEU vs Target Mes</p>
                    <div class="adaptiv">
                        <canvas id="canvas4" class="canvas-grafico">
                            {{teuvstargetejecutivo4}}
                        </canvas>
                    </div>
                </div>
            </div>
            <div class="graficoscontenedor">
                <div class="graficos" [ngClass]="{'precarga': dato2 === false}">
                    <p class="titulosgraficos">Consignatarios recuperados 12 meses</p>
                    <div class="adaptiv">
                        <canvas id="canvasClientesRecuperados" class="canvas-grafico">
                            {{chartClientesRecuperados}}
                        </canvas>
                    </div>
                </div>
            
                <div class="graficos">
                    <p class="titulosgraficos">TEU por Línea</p>
                    <div class="adaptiv">
                        <canvas id="canvas2" class="canvas-grafico">
                            {{teuvstargetejecutivo2}}
                        </canvas>
                    </div>
                </div>
            </div> -->
        </div>
    </p-tabPanel>

  


</p-tabView>



<div style="height: 60px;" class="footer">

</div>